/**
 * SSE Notification Manager
 * 
 * Uses a Valtio proxy state to hold the current SSE toast notification.
 * The useSSE hook subscribes to this state and renders the Toast component.
 * 
 * This is consistent with the app's existing Valtio patterns (pState, authState, tState).
 */

import { proxy } from 'valtio';

/**
 * Valtio proxy state for the current SSE toast notification.
 * @type {{ current: { type: string, title: string, message: string } | null }}
 */
export const toastState = proxy({ current: null });

export const notificationManager = {
    /**
     * Show a toast notification
     * @param {object} notification
     * @param {string} [notification.type='info'] - Alert type: 'info' | 'success' | 'warning' | 'error'
     * @param {string} notification.title - Translation key for the title
     * @param {string} notification.message - Translation key for the message
     * @param {Array<string|number>} [notification.values] - Fills ${1}, ${2}... in the message
     */
    show({ type = 'info', title, message, values }) {
        toastState.current = { type, title, message, values };
    },

    /**
     * Clear the current toast notification
     */
    clear() {
        toastState.current = null;
    }
};
